import React, { useEffect, useCallback, useRef, useContext } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import KeycloakContext from "../context/keycloakContext";

import { setAccessToken } from "../services/httpService";

const withActivityTracer = (Component) => (props) => {
  const keycloak = useContext(KeycloakContext);

  let timeStamp = useRef();
  let timerInterval = useRef();
  let warningInterval = useRef();

  // reset interval timer
  const resetTimer = useCallback(() => {
    clearTimeout(timerInterval.current);
    clearInterval(warningInterval.current);

    if (keycloak.authenticated) {
      let time = timeStamp.current;
      time = moment();
      sessionStorage.setItem("lastTimeStamp", time);
    } else {
      clearInterval(warningInterval.current);
      sessionStorage.removeItem("lastTimeStamp");
    }
  }, [keycloak]);

  // refresh token
  const refreshToken = useCallback(() => {
    keycloak
      .updateToken()
      .then(() => setAccessToken(keycloak.token))
      .catch(() => toast.warn("Please refresh the page before continuing!"));
  }, [keycloak]);

  // track user inactivity
  useEffect(() => {
    const events = ["click", "load", "mousedown", "keydown"];
    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
      window.addEventListener(event, refreshToken);
    });

    // Capture the current value of timerInterval in the effect
    const currentTimerInterval = timerInterval.current;

    return () => {
      // Use the captured value in the cleanup function
      clearTimeout(currentTimerInterval);
    };
  }, [resetTimer, refreshToken]);

  return <Component {...props} />;
};

export default withActivityTracer;
